import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { ROUTES } from 'module/navigation/enums/routes.enums';

type RouteParams = {
	id: string;
};

type ToDoScheduleEventDetailMode = 'view' | 'edit';

interface ToDoScheduleEventDetailProps {
	mode: ToDoScheduleEventDetailMode;
}

/** Legacy route — recurring todo occurrences are regular todos; redirect to standard pages. */
const ToDoScheduleEventDetail = ({ mode }: ToDoScheduleEventDetailProps) => {
	const { id } = useParams<RouteParams>();
	const history = useHistory();

	useEffect(() => {
		const route =
			mode === 'edit'
				? ROUTES.EDIT_TO_DO.replace(':id', id)
				: ROUTES.TO_DO_ID.replace(':id', id);
		history.replace(route);
	}, [mode, id, history]);

	return (
		<Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
			<CircularProgress />
		</Box>
	);
};

export default ToDoScheduleEventDetail;
